export default __webpack_public_path__ + "5cb1522ffb0379d6c0a3d4b4c9607208.png";